import React from 'react';
import XIcon from './icons/XIcon';
import type { User, Language } from '../types';
import TermsContent_en from './terms_of_service/TermsContent_en';
import TermsContent_he from './terms_of_service/TermsContent_he';
import TermsContent_es from './terms_of_service/TermsContent_es';
import TermsContent_ar from './terms_of_service/TermsContent_ar';
import TermsContent_de from './terms_of_service/TermsContent_de';
import TermsContent_fr from './terms_of_service/TermsContent_fr';
import { getTranslation } from '../utils/translations';

interface TermsOfServiceModalProps {
    isOpen: boolean;
    onClose: () => void;
    user?: User | null;
    language?: Language;
    onAccept?: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ isOpen, onClose, user, language: languageOverride, onAccept }) => {
    const language: Language = languageOverride || user?.language || 'en';
    const t = (key: any) => getTranslation(language, key);
    
    if (!isOpen) return null;

    const showAcceptButton = onAccept && user && !user.acceptedTerms;

    const renderContent = () => {
        switch (language) {
            case 'he': return <TermsContent_he />;
            case 'es': return <TermsContent_es />;
            case 'ar': return <TermsContent_ar />;
            case 'de': return <TermsContent_de />;
            case 'fr': return <TermsContent_fr />;
            case 'en':
            default: return <TermsContent_en />;
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col relative" onClick={e => e.stopPropagation()}>
                <div className="p-6 border-b flex justify-between items-center bg-slate-50 rounded-t-xl">
                    <h2 className="text-xl font-bold text-slate-800">{t('termsOfService')}</h2>
                    <button onClick={onClose} className="text-slate-500 hover:text-slate-800 p-1">
                        <XIcon className="h-6 w-6" />
                    </button>
                </div>

                <div className="p-6 overflow-y-auto">
                    <div className="mb-4">
                        <p className="font-bold text-sm text-slate-500">Last Updated: {new Date().toLocaleDateString()}</p>
                    </div>
                    {renderContent()}
                </div>

                <div className="p-4 bg-slate-50 border-t rounded-b-xl flex justify-end gap-3">
                    <button 
                        onClick={onClose}
                        className={`px-4 py-2 text-slate-700 font-medium rounded-md hover:bg-slate-200 transition-colors ${showAcceptButton ? 'bg-transparent' : 'bg-slate-200'}`}
                    >
                        {showAcceptButton ? t('cancel') : t('close')}
                    </button>
                    {showAcceptButton && (
                        <button 
                            onClick={onAccept}
                            className="px-6 py-2 bg-sky-600 text-white font-bold rounded-md hover:bg-sky-700 transition-colors shadow-sm"
                        >
                            {t('agreeContinue')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TermsOfServiceModal;